import { Pipe, PipeTransform } from '@angular/core';
import { CONTACT_SOURCES } from 'core/shared-constants';
import { isNil } from 'lodash-es';

/*
 * Human friendly name of contact source
 */
@Pipe({ name: 'source' })
export class SourcePipe implements PipeTransform {
  transform(value: any): string {
    if (isNil(value)) {
      return '';
    }
    value = value as string;

    return CONTACT_SOURCES[value]?.name;
  }
}
